import { render, staticRenderFns } from "./settings-profile-change.vue?vue&type=template&id=facfec34&"
import script from "./settings-profile-change.vue?vue&type=script&lang=js&"
export * from "./settings-profile-change.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports